// LIBRARIES
import styled, { css } from "styled-components";

// MISC
import { COLORS, FONTS, WIDTH } from "constants/styleVariables";

export const Container = styled.div`
  // @media screen and (max-width: 1250px) {
  //   padding: 30px 30px 0px 30px;
  //   margin: 0 auto;
  // }
  // @media screen and (min-width: 1250px) {
  //   padding: 60px 80px 0px 80px;
  // }
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
`;

export const Title = styled.text`
  font-size: 20px;
  font-weight: bold;
  color: ${COLORS.terraCotta};
  font-family: ${FONTS.montserrat};
  margin-left: 50px;
`;

export const Bar = styled.div`
  padding: 1px;
  background-color: ${COLORS.backgroundColor};
  margin-top: 10px;
`;

export const Info = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${COLORS.rainbowIndigo};
  font-family: ${FONTS.montserrat};
  margin-right: 10px;
  margin-bottom: 20px;
`;

export const UsersList = styled.div`
  margin-top: 20px;
  height: 280px;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  overflow-y: scroll;
  padding-right: 20px;
  margin-right: 50px;
  ::-webkit-scrollbar {
    width: 3px;
  }
  ::-webkit-scrollbar-track {
    background-color: ${COLORS.backgroundColor};
    border-radius: 10px;
    margin-block: 9px;
    margin-left: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background-image: linear-gradient(
      180deg,
      ${COLORS.rainbowIndigo} 0%,
      ${COLORS.rainbowIndigo} 100%
    );
`;

export const UserIcon = styled.img`
  width: 30px;
  height: 30px;
  margin-right: 12px;
  border-radius: 50px;
  background-color: ${COLORS.secondaryGray}
`;

export const UserName = styled.div`
  font-size: 16px;
  font-family: ${FONTS.montserrat};
  color: ${COLORS.rainbowIndigo};
  font-weight: 600;
  height: 48px;
  display: flex;
  align-items: center;
  `;

export const UserContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 47.8px;
  width: 100%;
  align-items: center;
  border-bottom: 3px solid #EAE8E8;
  cursor: pointer;
`;

export const Bar2 = styled.div`
  padding: 1px;
  background-color: ${COLORS.backgroundColor};
  margin-top: 10px;
  margin-bottom: 10px
`;

export const NotificationBar = styled.div`
  padding: 1px;
  background-color: ${COLORS.backgroundColor};
  width: 400px;
  margin: 10px 0;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;
export const SendNotificationsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 767px;
  background-color: #F5F5F5;
  margin-right: 10px;
  border-radius: 20px;
  padding: 25px 0 0px 0;
`;

export const TitleInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 50px;
  margin-bottom: 30px;
`;

export const SendTitle = styled.div`
  font-size: 15px;
  font-weight: bold;
  color: ${COLORS.rainbowIndigo};
  font-family: ${FONTS.montserrat};
  margin-bottom: 5px;
`;

export const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 50px;
`;
export const BodyTitle = styled.div`
  font-size: 15px;
  font-weight: bold;
  color: ${COLORS.rainbowIndigo};
  font-family: ${FONTS.montserrat};
  margin-bottom: 5px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: flex-end;
`;
export const NotificationsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 860px;
  max-width: 600px;
  height: 767px;
  background-color: #F5F5F5;
  border-radius: 20px;
  padding: 25px 0;
`;

export const NotificationsListTitle = styled.div`
  font-size: 15px;
  font-weight: bold;
  color: ${COLORS.rainbowIndigo};
  font-family: ${FONTS.montserrat};
`;

export const NotificationsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 430px;
  height: 85%;
  padding-left: 30px;
  padding-right: 30px;
  margin-right: 15px;
  color: blue;
  // overflow: hidden;
  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 4px;
  }
  ::-webkit-scrollbar-track {
    background-color: ${COLORS.backgroundColor};
    border-radius: 10px;
    margin-block: 9px;
  }
  ::-webkit-scrollbar-thumb {
    background-image: linear-gradient(
      180deg,
      ${COLORS.cornflowerBlue} 0%,
      ${COLORS.rainbowIndigo} 100%
    );
    border-radius: 10px;
  }
`;

export const NotificationContainer = styled.div`
  display: flex;
  flex-direction: row;
  // position: relative;
  // min-width: 400px;
  width: 100%;
  border-bottom: 2px solid #EAE8E8;
  padding-bottom: 10px;
  margin-bottom: 10px;
  justify-content: space-between;
  align-items: center;
  svg {
    margin-left: 0px;
    color: ${COLORS.rainbowIndigo};
    cursor: pointer;
  }
`;

export const PromoCodeRow = styled.div`
  display: flex;
  align-items: center;
`;

export const LeftContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 50%;
  height: 110px;
`;

export const NotificationTitle = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: ${COLORS.rainbowIndigo};
  font-family: ${FONTS.montserrat};
  margin-bottom: 5px;
`;

export const NotificationBodyText = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${COLORS.secondaryBlack};
  font-family: ${FONTS.montserrat};
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 5px;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
`;
export const RightContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: end;
`;

export const NotificationDate = styled.text`
  font-size: 12px;
  color: ${COLORS.primaryGray};
  font-family: ${FONTS.montserrat};
  margin-left: 5px;
`;

export const NotificationDateContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  // width: 100%;
  // padding-bottom: 10px;
  // margin-bottom: 10px;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
`;

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 217px;
  height: 100%;
  border-right: 3px solid #EAE8E8;
  padding-top: 30px;
`;

export const RightContainer = styled.div`
  padding: 30px 20px 40px 30px;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const DicountType = styled.div(
  ({ isSelected }) => css`
  width: 217px;
  height: 58px;
  background-color: ${isSelected ? "#2934624D" : "transparent"};
  display: flex;
  justify-content: center;
  align-items: center;
  color: #293462;
  font-family: ${FONTS.newsharp};
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
`);

export const Subtitle = styled.div`
  font-family: ${FONTS.montserrat};
  font-weight: 600;
  font-size: 16px;
  color: #101010;
  margin-bottom: 10px;
`;

export const SecondLine = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 30px;
  align-items: center;
  @media (${WIDTH.mediumWidth}) {
    flex-direction: column;
  }
`;

export const InputAtomContainer = styled.div(
  ({ width }) => css`
    width: ${width ? width : "300px"};
    @media screen and (min-width: 1451px) {
      margin-right: 80px;
    }
    @media screen and (max-width: 1450px) {
      margin-right: 30px;
    }
  `
);

export const InputAtomContainer2 = styled.div(
  ({ width }) => css`
    width: ${width ? width : "300px"};
    @media screen and (min-width: 1451px) {
      margin-right: 80px;
    }
    @media screen and (max-width: 1450px) {
      margin-right: 30px;
    }
    @media (${WIDTH.mediumWidth}) {
      margin-top: 30px;
    }
  `
);

export const ThirdLine = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 30px;
`;

export const DisablePromoCode = styled.div`
    position: absolute;
    right: 0px;

`;

export const PromoCodeInfo = styled.div`
    display: flex;
    flex-direction: column;
`;

export const PromoCodeType = styled.div`
  font-size: 12px;
  color: #1D1B23;
  font-family: ${FONTS.montserrat};
`;

export const ClockIconImage = styled.img``;

export const AddCategory = styled.div`
  font-size: 14px;
  color: ${COLORS.rainbowIndigo};
  font-weight: 600;
  font-family: ${FONTS.poppins};
  text-align: center;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  display: flex;
  text-decoration: underline;
`;

export const ImageContainer = styled.img`
  margin-right: 10px;
  margin-bottom: 2px;
`;

export const AddUsersRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const NumberOfUsers = styled.div`
  font-family: ${FONTS.montserrat};
  font-size: 12px;
  font-weight: 600;
  margin-right: 64px;
  color: ${COLORS.newOrange}
`;

export const PromoCodeSubtitle = styled.div`
font-family: ${FONTS.montserrat};
font-size: 16px;
font-weight: 600;
color: #1D1B23;
margin-top: 20px;
margin-bottom: 20px;
`;

export const InactiveTitle = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: #67686A;
  font-family: ${FONTS.montserrat};
  margin-bottom: 5px;
`;

export const InactivePromoCodeType = styled.div`
  font-size: 12px;
  color: #1D1B23;
  font-family: #A2A5B1;
`;


